const Theme = () => {
    // Function for setting cookies
    function setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = `expires=${date.toUTCString()}`;
        document.cookie = `${name}=${value}; ${expires}; path=/`;
    }

    // Function for getting the cookie value
    function getCookie(name) {
        const cookieArray = document.cookie.split(';');
        for (let i = 0; i < cookieArray.length; i++) {
            const cookie = cookieArray[i].trim();
            if (cookie.indexOf(`${name}=`) === 0) {
                return cookie.substring(name.length + 1);
            }
        }
        return '';
    }

    // Function for applying the theme
    function applyTheme(theme) {
        const htmlElement = document.documentElement;
        if (theme === 'light') {
            htmlElement.classList.add('light-theme');
            htmlElement.classList.remove('dark-theme');
        } else {
            htmlElement.classList.add('dark-theme');
            htmlElement.classList.remove('light-theme');
        }
    }

    // Apply saved theme on load
    const savedTheme = getCookie('siteTheme');
    applyTheme(savedTheme || 'light');

    // Add click listeners to all switchers
    const switchers = document.querySelectorAll('[data-theme="theme-switch"]');

    switchers.forEach((switcher) => {
        switcher.addEventListener('click', () => {
            const currentTheme = document.documentElement.classList.contains('dark-theme') ? 'light' : 'dark';
            applyTheme(currentTheme);
            setCookie('siteTheme', currentTheme, 30);
        });
    });
};

export default Theme;
